import { CardContent, Stack } from "@mui/material";
import { Illustration, Text, Title } from "@src/appV2/redesign/system/ui-components";

import { ShiftDetailsInnerCard } from "./InnerCard";

export function UploadTimesheetCard() {
  return (
    <ShiftDetailsInnerCard>
      <CardContent>
        <Stack spacing={6} alignItems="center" sx={{ paddingX: 4, paddingY: 4 }}>
          <Illustration type="document-upload" />
          <Title semibold variant="h5" component="h3">
            Upload Timesheet
          </Title>
          <Text
            variant="body2"
            sx={{ color: (theme) => theme.palette.text.secondary, textAlign: "center" }}
          >
            Your shift is no longer InstantPay-eligible. Don&apos;t worry, you&apos;ll still be
            paid. Please upload a timesheet at the end of your shift.
          </Text>
        </Stack>
      </CardContent>
    </ShiftDetailsInnerCard>
  );
}
